import * as CommonComponentActions from './action';
const initialState = {
    automationInitiatedSuccess: [],
    automationInitiatedFailure: [],
    kycAutomationInitiatedSuccess: [],
    kycAutomationInitiatedFailure: [],
    crawlerStatusSuccess: [],
    crawlerStatusFailure: [],
    CrawlerMarkasfailSuccess: [],
    CrawlerMarkasfailFailure: [],
    KycCrawlerStatusSuccess: [],
    KycCrawlerStatusFailure: [],
    legalCrawler: {},
    zigramData:{},
    masterDataSyncData: null,
    masterDataSyncStatus: null,
    masterDataSyncError: null,
    itrResyncStatus: null,
    itrResyncMessage: null,
    itrResyncAt: null
}

const commonComponentReducer = (state = initialState, action) => {
    switch (action.type) {
        case CommonComponentActions.DATA_AUTOMATION_INITIATE_SUCCESS:
            return state = {
                ...state,
                automationInitiatedSuccess: action.data
            }
        case CommonComponentActions.DATA_AUTOMATION_INITIATE_FAILURE:
            return state = {
                ...state,
                automationInitiatedFailure: action.data
            }
        case CommonComponentActions.KYC_DATA_AUTOMATION_INITIATE_SUCCESS:
            return state = {
                ...state,
                kycAutomationInitiatedSuccess: action.data
            }
        case CommonComponentActions.KYC_DATA_AUTOMATION_INITIATE_FAILURE:
            return state = {
                ...state,
                kycAutomationInitiatedFailure: action.data
            }
        case CommonComponentActions.GET_CRAWLER_STATUS_SUCCESS:
            return state = {
                ...state,
                crawlerStatusSuccess: action.data
            }
        case CommonComponentActions.GET_CRAWLER_STATUS_FAILURE:
            return state = {
                ...state,
                crawlerStatusFailure: action.data
            }
            
            case CommonComponentActions.GET_CRAWLER_MARKASFAIL_SUCCESS:
            return state = {
                ...state,
                crawlerMarkasfailSuccess: action.data
            }
        case CommonComponentActions.GET_CRAWLER_MARKASFAIL_FAILURE:
            return state = {
                ...state,
                crawlerMarkasfailFailure: action.data
            }
            
            case CommonComponentActions.GET_KYC_CRAWLER_STATUS_SUCCESS:
                return state = {
                    ...state,
                    KycCrawlerStatusSuccess: action.data
                }
            case CommonComponentActions.GET_KYC_CRAWLER_STATUS_FAILURE:
                return state = {
                    ...state,
                    KycCrawlerStatusFailure: action.data
                }
    
        case CommonComponentActions.LEGAL_CRAWLER_RESPONSE:
            return {
                ...state,
                legalCrawler: action.data
            }

        case CommonComponentActions.LEGAL_SETCION_TEMPLATES_RESPONSE:
            return {
                ...state,
                legalSectionData: action.data
            }

        case CommonComponentActions.NIC_SEARCH_RESPONSE:
            return {
                ...state,
                nicSearchResultList: action.data
            }

        case CommonComponentActions.ZIGRAM_SEARCH_RESPONSE:
            return {
                ...state,
                zigramData: action.data
            }

            case CommonComponentActions.ZIGRAM_EXCEL_RESPONSE:
                return {
                    ...state,
                    zigramExcelData: action.data
                }    

        case CommonComponentActions.ADDITIONAL_LEGAL_TEMPLATE_RESPONSE:
            return {
                ...state,
                additionalLegalTemplate: action.data
            }

        case CommonComponentActions.ADDITIONAL_LEGAL_UPLOAD_RESPONSE:
            return {
                ...state,
                additionalLegalUploadResponse: action.data
            }

            case CommonComponentActions.AML_PEP_TEMPLATE_RESPONSE:
                return {
                    ...state,
                    amlPepTemplate: action.data
                }
            
        case CommonComponentActions.MASTER_DATA_SYNC_RESPONSE:
    return {
        ...state,
        masterDataSyncData: action.data.data,
        masterDataSyncStatus: action.data.status,
        masterDataSyncError: action.data.status === "FAILURE" ? action.data.data : null
    };

        case CommonComponentActions.ITR_ANALYSIS_RESYNC_RESPONSE:
            return {
                ...state,
                itrResyncStatus: action.data.status,
                itrResyncMessage: action.data.status === "SUCCESS"
                    ? (action.data.data && action.data.data.message) || "ITR analysis resync queued"
                    : action.data.message,
                itrResyncAt: action.data.at
            };

        default: return state
    }
};

export default commonComponentReducer;